/**
 * ctaStore — paywall global (porta de `showCTA` [application.js:2325]). Qualquer ponto do
 * app que detecte acesso expirado abre o CTA com a ferramenta correspondente. "Tenho um código
 * de ativação" (Conta › Licença, no teste) abre a mesma janela já no campo do código.
 */
import { create } from 'zustand';

export type CtaTool = 'default' | 'lead-explorer';
export type CtaStart = 'offer' | 'unlock';

interface CtaState {
  tool: CtaTool | null;
  /** Etapa em que a janela abre. */
  start: CtaStart;
  openCTA: (tool?: CtaTool, start?: CtaStart) => void;
  closeCTA: () => void;
}

export const useCtaStore = create<CtaState>((set) => ({
  tool: null,
  start: 'offer',
  openCTA: (tool = 'default', start = 'offer') => set({ tool, start }),
  closeCTA: () => set({ tool: null }),
}));
